import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { RootState } from "../app/store";

const PageWrapper = styled.div`
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  background: #000;
`;

const WidgetFrame = styled.iframe`
  width: 100%;
  min-height: 700px;
  border: 0;
  display: block;
  border-radius: 12px;
  background: #111;
`;

interface IframeMessageData {
  type: string;
  data?: any;
  height?: number;
}

const OMEGAJAM_ORIGIN = "https://omegajam.com";
const DEFAULT_IFRAME_HEIGHT = 700;
const RESET_IFRAME_HEIGHT = "115vh";

const OmegaJamAcademyPage: React.FC = () => {
  const user = useSelector((state: RootState) => state.authSlice.user);
  const token = localStorage.getItem("token");
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const lastHeightRef = useRef<number>(DEFAULT_IFRAME_HEIGHT);

  useEffect(() => {
    if (!token) return;

    const iframe = iframeRef.current;
    if (!iframe) return;

    iframe.style.height = `${DEFAULT_IFRAME_HEIGHT}px`;

    const handleLoad = () => {
      iframe.contentWindow?.postMessage(
        {
          type: "IFRAME_LOADED",
          data: { isLoaded: true },
        },
        OMEGAJAM_ORIGIN
      );
    };

    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== OMEGAJAM_ORIGIN) return;

      const message: IframeMessageData = event.data;
      if (!message || typeof message.type !== "string") return;

      if (message.type === "REQUEST_JWT") {
        const latestToken = localStorage.getItem("token");

        if (event.source && latestToken) {
          const payload = {
            type: "DELIVER_JWT",
            token: latestToken,
            email: user?.email || "",
            username: user?.username || "",
          };

          console.log("Parent sending payload to iframe:", payload);
          (event.source as Window).postMessage(payload, event.origin);
        }
        return;
      }

      if (message.type === "IFRAME_HEIGHT_RESET") {
        iframe.style.height = RESET_IFRAME_HEIGHT;
        console.log("Iframe height reset to:", iframe.style.height);
        return;
      }

      if (message.type === "IFRAME_HEIGHT" && typeof message.height === "number") {
        const roundedHeight = Math.ceil(message.height);

        console.log("Received iframe height:", roundedHeight);

        if (roundedHeight === lastHeightRef.current) return;

        lastHeightRef.current = roundedHeight;
        iframe.style.height = `${roundedHeight}px`;

        console.log("Applied iframe height:", iframe.style.height);
      }
    };

    iframe.addEventListener("load", handleLoad);
    window.addEventListener("message", handleMessage);

    return () => {
      iframe.removeEventListener("load", handleLoad);
      window.removeEventListener("message", handleMessage);
    };
  }, [token, user]);

  if (!token) {
    return (
      <PageWrapper>
        <div style={{ color: "#fff", textAlign: "center", paddingTop: "40px" }}>
          Please login to access OmegaJam Academy.
        </div>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <WidgetFrame
        ref={iframeRef}
        src="https://omegajam.com/widget/Academy"
        title="OmegaJam Academy Widget"
        allow="fullscreen; clipboard-read; clipboard-write"
      />
    </PageWrapper>
  );
};

export default OmegaJamAcademyPage;